
export const TYPE_CDT = {
  TECHNICAL_TRANSFER: "technicalTransfer",
  DIRECT_DOWN_LINE: "directDownline",
  CONSULTATION:"consultation",
}

export const STATUS_PLAN_SLIP = {
  CHO_DANH_GIA: "waiting_review",
  DA_DUYET: "approved",
  BAO_CAO_KET_QUA: "report_results",
  DA_DANH_GIA: "evaluated",
  LUU_MOI: "new_save",
  APPROVED: "approved",
}
